import React from "react";

import { coreFourSubjectList } from "@examspark/common/dist/meta/assets";
import { subjectMeta } from "@examspark/common-meta";
import { SelectInput, SelectInputOption } from "@examspark/common-ui";
import { Subject } from "@examspark/types";

const SubjectSelectInput = (
  props: React.ComponentProps<
    typeof SelectInput<string, SelectInputOption<string>, false>
  > & {
    allowedSubjects?: string[];
    overrideSubjects?: Subject[];
  },
) => {
  let subjectsToShow: Subject[];

  if (props.overrideSubjects != null) {
    // override subjects - ignore everything else
    subjectsToShow = props.overrideSubjects;
  } else {
    // default - get workspace subjects and optionally filter by allowedSubjects
    const availableSubjects = coreFourSubjectList;
    subjectsToShow = props.allowedSubjects
      ? availableSubjects.filter((subject) =>
          props.allowedSubjects!.includes(subject),
        )
      : availableSubjects;
  }

  return (
    <SelectInput<string, SelectInputOption<string>, false>
      options={subjectsToShow.map((subject) => {
        return {
          label: subjectMeta[subject].label,
          value: subject,
        };
      })}
      {...props}
    />
  );
};

export default SubjectSelectInput;
